export const AUTH_ENTRY_STEP = {
    PHONE_NUMBER_FORM: 1,
    OTP_VERIFICATION_FORM: 2,
}

export const DEFAULT_STEP = AUTH_ENTRY_STEP.AUTH_ENTRY;